import { render } from "./BTWallCellsMobile.vue?vue&type=template&id=09dec179&scoped=true"
import script from "./BTWallCellsMobile.vue?vue&type=script&lang=js"
export * from "./BTWallCellsMobile.vue?vue&type=script&lang=js"

import "./BTWallCellsMobile.vue?vue&type=style&index=0&id=09dec179&scoped=true&lang=css"

import exportComponent from "/home/dr/PhpstormProjects/anh/vue/scheduleweek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dec179"]])

export default __exports__